import { SET_USER_ROUTER, ASYNC_ROUTER_MARK, SET_TABLEDATA } from "./actionTypes";
import { Commit } from "vuex";
export default {
  [SET_USER_ROUTER]({ commit }: { commit: Commit }, data: []) {
    commit(SET_USER_ROUTER, data);
  },
  [ASYNC_ROUTER_MARK]({ commit }: { commit: Commit }, data: []) {
    commit(ASYNC_ROUTER_MARK, data);
  },
  [SET_TABLEDATA]({ commit }: { commit: Commit }, data: []) {
    commit(ASYNC_ROUTER_MARK, data);
  },
};
